/* eslint-disable */
import { connect } from 'react-redux';
import { Visibility } from '@mui/icons-material';
import styles from './OrderHistoryListPage.module.scss';
import analyticsAction from '../../../Actions/analytics.actions';
import { classes } from '../../../Helpers';
import { ListTable } from '../../../Components/ListTable';
import { ArrangePages } from '../../../Components/Arrange Pages';
import orderAnalyticsServices  from '../../../Services/Analytics Services/orderAnalytics.services';
import { modalActions } from '../../../Actions';
import { notificationServices } from '../../../Services';
import locateIcon from '../../../Images/locate.svg';
import { urls } from '../../../Constants';
import OrderImagesModal from '@/Components/Modals/OrderImagesModal/OrderImagesModal';

const COLMAP = {
	'Order Id': 'orderId',
	'Partner Order Id': 'partnerOrderId',
	'Order Time': 'orderTime',
	Store: 'storeName',
	'Order Status': 'orderStatus',
	'Payment Amount': 'paymentAmount',
	'Order Scheduled': 'scheduledAt',
	'Order Type': 'mealType',
	'Payment Mode': 'paymentType',
	'Payment Status': 'paymentStatus',
	'Mobile Number': 'mobile',
	Address: 'orderId',
	Traceability: 'traceability',
	'Total Items': 'itemCount',
	'View Items': 'orderId',
	'Trace Order': 'orderId',
	'View Images': 'orderId',
};

const TABLE_COLUMNS = [
	{
		title: 'Order Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Partner Order Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Time',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Scheduled',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Payment Mode',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Payment Amount',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Payment Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Mobile Number',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Address',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Total Items',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'View Items',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Traceability',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Trace Order',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'View Images',
		config: {
		  type: 'DATA',
		},
	  },
];

const ACTION_COLUMNS = [];

const getRowStyles = (item) => {
	switch (item?.batchStatus) {
		case 'CLOSED':
			return styles.normal;
		case 'COOKING':
			return styles.moderate;
		default:
			return styles.white;
	}
};

const OrderHistoryList = (props) => {
	// const history = useHistory();
	const {
		page,
		limit,
		nextPage,
		prevPage,
		setPage,
		data,
		storeId,
		setAnalyticsType,
		ANALYTICS_TYPE,
		timeType,
		orderStatus,
		hasMore,
		SEARCH_BY,
		searchField,
		query,
		fetchData,
		queryTracker,
		toggleOrderItemsModal,
		handleOrderHistoryCsv = () => {},
		allowExport = false,
		reqOptions,
		toggleOrderImagesModal
	} = props;

	// Mock 
	// {
	// 	"itemId": 8450956,
	// 	"name": "Choco Crunch KitKat Cake",
	// 	"variant": "1 Kg (-)",
	// 	"variantId": 22714,
	// 	"category": "Cake",
	// 	"count": 1,
	// 	"amount": 1050,
	// 	"traceability": []
	// }

	const handleViewImages = async (orderId) => {
		try {
		  const responseImages = await orderAnalyticsServices.viewOrderImages({
			data: { orderId: orderId, orderType: "customerOrder" },
			// orderType: "customerOrder"
		  });
		  const responseItems = await orderAnalyticsServices.fetchOrderItems({
			data: {
				orderId: orderId,
			},
		});
		
		  if (responseImages?.data?.length > 0) {
			const merged = responseImages?.data.map(image => {
				const matchingProduct = responseItems?.data?.items?.find(product => product.itemId === image.itemId);
				return {
				  ...image,
				  ...matchingProduct
				};
			  });
			  
			// setOrderImages(merged);
			// setOrderImages(response.data);
			// fetchProductData('75464')
			// setImageModalOpen(true);
			toggleOrderImagesModal(true,{
				orderImages: merged
			})
		  } else {
			notificationServices.generateNotification({
			  type: 'info',
			  message: 'No images found for this order.',
			});
		  }
		} catch (error) {
		  notificationServices.generateNotification({
			type: 'error',
			message: 'Failed to fetch images.',
		  });
		}
	  };
	
	const handleCancel = async (orderData) => {
		try {
			const response = await orderAnalyticsServices.cancelOrder({
				orderData,
			});
			if (response?.data?.status === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.data?.message,
				});
				fetchData(reqOptions);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.data?.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message ?? error,
			});
			// console.log(error);
		}
	};

	const openModal = async (id) => {
		try {
			const response = await orderAnalyticsServices.fetchOrderItems({
				data: {
					orderId: id,
				},
			});
			toggleOrderItemsModal(true, {
				items: response?.data?.items,
				orderId: id,
			});
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const SPECIAL_ITEMS = {
		'View Items': (orderId) => {
			return (
				<div
					className={styles['order-item-view']}
					onClick={() => openModal(orderId)}
				>
					<Visibility className={styles.icon} />
				</div>
			);
		},
		Address: (orderId) => {
			const item = data?.find((ele) => {
				return ele.orderId === orderId;
			});
			return `${item?.addressLine1 ?? ''} ${item?.addressLine2 ?? ''} ${
				item?.city ?? ''
			} ${item?.state ?? ''}`;
		},
		'Trace Order': (orderId) => {
			const item = data?.find((ele) => {
				return ele.orderId === orderId;
			});
			if (item?.traceability <= 0) {
				return '-';
			}
			return (
				<div
					onClick={() => {
						window.open(
							// eslint-disable-next-line prefer-template
							urls.EXTENSION +
								urls.ORDER_TRACKNG +
								'?type=orderId&value=' +
								item?.orderId,
							'_blank'
						);
					}}
					className={styles.locate}
				>
					<img src={locateIcon} alt='locate' />
				</div>
			);
		},
		'View Images': (orderId) => {
			return (
				<div
					className={styles['order-item-view']}
					onClick={() => handleViewImages(orderId)}
				>
					<Visibility className={styles.icon} />
				</div>
			);
		},
	};

	return (
		<div className={classes(styles.root, 'list-page-root')}>
			<ListTable
				hasDateRange
				colMap={COLMAP}
				special={SPECIAL_ITEMS}
				fixedHeaderTop={0}
				data={
					data &&
					data.map((obj, idx) => {
						const rowStyles = getRowStyles(obj);
						// const itemId = get(obj, COLMAP['Item Id']);
						// const qc = get(obj, COLMAP.qc);
						return {
							...obj,
							id: idx + 1,
							rowStyles,
							// onClick: () => {
							// history.push(
							// `${urls.EXTENSION}${urls.PAST_QC}/${itemId}?id=${qc}`
							// );
							// },
						};
					})
				}
				columns={[...TABLE_COLUMNS]}
				actions={[...ACTION_COLUMNS]}
				handleDelete={handleCancel}
				onExportClick={handleOrderHistoryCsv}
				allowExport={allowExport}
			/>
			<ArrangePages
				hasMore={!!hasMore}
				page={page}
				limit={limit}
				nextPage={nextPage}
				prevPage={prevPage}
				setPage={setPage}
				fetchData={fetchData}
				reqOptions={reqOptions}
				setAnalyticsType={setAnalyticsType}
				ANALYTICS_TYPE={ANALYTICS_TYPE}
				query={query}
				queryTracker={queryTracker}
			/>
			<OrderImagesModal />
		</div>
	);
};

const mapStateToProps = () => {
	return {};
};
const mapDispatchToProps = {
	toggleOrderItemsModal: modalActions.toggleOrderItemsModal,
	setAnalyticsType: analyticsAction.setAnalyticsType,
	toggleOrderImagesModal: modalActions.toggleOrderImagesModal
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderHistoryList);
